import {$http} from '@/utils/https'

import {
    GET_CONFIG_LOADING,
    GET_COUNTRIES_LOADING,
    GET_TIMEZONES_LOADING,
    SET_CONFIG,
    SET_COUNTRIES,
    SET_COUNTRY,
    SET_SERVER_TIME,
    SET_SETTING,
    SET_TIMEZONES,
    SET_TRANSLATIONS
} from '../mutation-types';

import {
    GET_CONFIG,
    GET_COUNTRIES,
    GET_COUNTRY,
    GET_SERVER_TIME,
    GET_SETTING,
    GET_TIMEZONES,
    GET_TRANSLATIONS
} from '../action-types';

const camelcaseObjectDeep = require('camelcase-object-deep')

const state = {
    config          : {},
    configLoading   : false,
    translations    : null,
    setting         : {},
    currentCountry  : null,
    countries       : [],
    countriesLoading: false,
    serverTime      : '',
    timezones       : [],
    timezonesLoading: false,
    defaultLocale   : {
        locale: 'en',
    }
};

const getters = {
    setting             : state => state.setting,
    translations        : state => state.translations,
    config              : state => state.config,
    configLoading       : state => state.configLoading,
    countries           : state => state.countries,
    countriesLoading    : state => state.countriesLoading,
    serverTime          : state => state.serverTime,
    currentCountry      : state => state.currentCountry,
    timezones           : state => state.timezones,
    timezonesLoading    : state => state.timezonesLoading,
    defaultLocale (state) {
        return window.detectedLocale ? {locale:window.detectedLocale} : state.defaultLocale;
    },
};

const actions = {
    [GET_CONFIG]        : async ({commit}) => {
        console.log('GET_CONFIG');
        
        commit(GET_CONFIG_LOADING, true);
        
        try {
            // TODO: currently there are no configs
            // const response = await $http.get(`${process.env.VUE_APP_ROOT_FAKE}`);

            commit(SET_CONFIG, {});
        } catch (e) {
            throw e;
        } finally {
            commit(GET_CONFIG_LOADING, false);
        }
    },
    [GET_SETTING]       : async ({commit}) => {
        console.log('GET_SETTING');
        
        try {
            const response = await $http.get(`${process.env.VUE_APP_ROOT_SETTING}site`);
            
            commit(SET_SETTING, response.data);
        } catch (e) {
            throw e;
        }
    },
    [GET_SERVER_TIME]   : async ({commit}) => {
        console.log('GET_SERVER_TIME');
        
        try {
            const response = await $http.get(`${process.env.VUE_APP_ROOT_SETTING}time`);
            
            commit(SET_SERVER_TIME, response.data.data.current);
        } catch (e) {
            throw e;
        }
    },
    [GET_COUNTRIES]     : async ({commit}) => {
        console.log('GET_COUNTRIES');
        
        try {
            commit(GET_COUNTRIES_LOADING, true)

            const response = await $http.get(`${process.env.VUE_APP_ROOT_COUNTRY}countries?include=timezones,locales`);
            
            commit(SET_COUNTRIES, response.data.data)
        } catch (e) {
            throw e;
        } finally {
            commit(GET_COUNTRIES_LOADING, false)
        }
    },// eslint-disable-next-line
    [GET_COUNTRY]       : async ({commit}, payload) => {
        console.log('GET_COUNTRY');
        
        try {
            const response = await $http.get(`${process.env.VUE_APP_ROOT_COUNTRY}countries/${payload.id}?include=timezones,locales,socials`);
            
            commit(SET_COUNTRY, response.data.data)
        } catch (e) {
            throw e;
        }
    },// eslint-disable-next-line
    [GET_TRANSLATIONS]  : async ({commit}) => {
        console.log('GET_TRANSLATIONS');
        
        try {
            const response = await $http.get(`${process.env.VUE_APP_ROOT_SETTING}translations`);

            commit(SET_TRANSLATIONS, response.data.data);

            return response.data.data;
        } catch (e) {
            throw e;
        }
    },
    [GET_TIMEZONES]     : async ({commit}, payload) => {
        console.log('GET_TIMEZONES');
        
        try {
            commit(GET_TIMEZONES_LOADING, true)

            // const response = await $http.get(`${process.env.VUE_APP_ROOT_SETTING}timezones?filters[keywords]=${payload.keywords}`)
            const response = await $http.get(`${process.env.VUE_APP_ROOT_SETTING}timezones?limit=500`);
            
            commit(SET_TIMEZONES, response.data.data)
        } catch (e) {
            throw e
        } finally {
            commit(GET_TIMEZONES_LOADING, false)
        }
    },
};

const mutations = {
    [SET_CONFIG](state, list) {
        state.config = list;
    },
    [SET_SETTING](state, setting) {
        state.setting = setting;
    },
    [SET_SERVER_TIME](state, data) {
        state.serverTime = data;
    },
    [GET_CONFIG_LOADING](state, status) {
        state.configLoading = status;
    },
    [SET_TRANSLATIONS](state, data) {
        state.translations = data;
    },
    [SET_COUNTRIES](state, data) {
        state.countries = data;
    },
    [GET_COUNTRIES_LOADING](state, status) {
        state.countriesLoading = status;
    },
    [SET_TIMEZONES](state, data) {
        state.timezones = camelcaseObjectDeep(
            data.map(e => {
                return {
                    name: `(GTM ${e.utcOffset}) ${e.name}`,
                    id: e.id,
                }
            })
        );
    },
    [SET_COUNTRY](state, data) {
        state.currentCountry = data;
        state.defaultLocale = data.locales.data.filter((item) => item.default === true);
    },
    [GET_TIMEZONES_LOADING](state, status) {
        state.timezonesLoading = status
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
